import React from "react"
import id from "@irati/utils/id"
import {Quantity, Plus, Minus} from "./styled/PlusMinus"
import QuantityWrapper from "./styled/QuantityWrapper"

export type QuantityPickerOnClick = (val: "-" | "+") => any

interface Props {
  id?: string,
  num: number,
  onClick: QuantityPickerOnClick,
  disabled: boolean
}

const QuantityPicker: React.FC<Props> = ({num, onClick, disabled, ...props}) => {
  return (
    <QuantityWrapper>
      <Minus id={id("minus", props)} onClick={() => (num === 0 ? false : onClick("-"))}>
        -
      </Minus>
      <Quantity id={id("value", props)} bold={num > 0}>
        {num}
      </Quantity>
      <Plus id={id("plus", props)} disabled={disabled} onClick={() => (disabled ? false : onClick("+"))}>
        +
      </Plus>
    </QuantityWrapper>
  )
}

QuantityPicker.defaultProps = {
  num: 0,
  onClick: () => {},
  disabled: false,
  id: "picker"
}

export default QuantityPicker
